<!-- 不合格登记 -->
<template>
   <div class='page_content'>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <unqualifiedRegisterAction v-if="showStatus" ref="unqualifiedRegisterAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></unqualifiedRegisterAction>
      </el-drawer>
      <subComponents @selectDataAction="selectDataAction" ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">

            </v-search>
         </div>
      </div>
      <div class="page_content_center">
         <el-table @selection-change="handleSelectionChange" size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                   highlight-current-row>
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip :min-width="tableValye.fieldWeight" v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                             :prop="tableValye.entityField" :label="tableValye.showField">
               <template slot-scope="scope">
                  <!-- <span v-if="tableValye.fieldType == 'date'">
							<span v-if="scope.row[tableValye.entityField]">
								{{$common.getLocalTime(scope.row[tableValye.entityField])}}
							</span>
						</span> -->
                  <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </span>
                  <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                  </span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                  </span>
                  <el-tag v-else-if="tableValye.entityField == 'rumState'" size="mini" type="primary">
                     {{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
                  <span v-else>
                     {{scope.row[tableValye.entityField]}}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import unqualifiedRegisterAction from '@/components/unqualifiedRegisterAction.vue'
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      unqualifiedRegisterAction
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            bgmId: "",
            bgmName: "",
            page: 1,
            rows: 30,
            start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
            end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,

         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],

         pageShowData: [],
         formDataList: [],
         selectData: [],
         selectedDataIndex: 0,
         DialogVisible: false,
         seWidth: "",
         parentSearchData: {
            smId: "",
         },
         seId: "",
         seIndex: "",
         seType: "",
         seTitle: "",
         showStatus: false,
         actionData: {}
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.bgmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.bgmId = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      // 处理表格选择变化
      handleSelectionChange(val) {
         this.selectData = val
      },
      // 子组件触发
      drawerCancel() {
         this.showStatus = false
         this.getDataList()
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页    
            var isPenetrate = true
            // 设置缓存 存入点击单号
            this.resetSetItem('penetrateOrderId', orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage({ //向窗口发送MessageEvent消息
               cmd: 'returnFormJson',
               params: {
                  isPenetrate
               } //参数
            }, '*');
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key == val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },
      selectDataAction(selectedData = {}, name, value) {
         switch (name) {
            case "bgmId":
               this.getRequestData.bgmId = selectedData.bgmId;
               this.getRequestData.bgmName = selectedData.bgmName;
               break;

            default:
               this.getRequestData[name] = value;
         }
      },

      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId]
         });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList();
            this.getButtonList();
            this.formDataList = this.pageShowData.jurFormVoList
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach(item => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      // 获取数据详情
      getDataDateils() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         dataInfo = JSON.parse(JSON.stringify(dataInfo));
      },

      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true
               this.actionData = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: '',
                  orderId: '',
                  printSouce: '',
                  printJurId: '',
                  returnData:this.returnData.list
               }
               
               break;
            case 1:
               if (this.returnData.list.length <= 0) {
                  this.$message({
                     message: "暂无数据",
                     type: "error",
                  });
                  return false;
               }
               if (this.selectData.length != 1) {
                  this.$message({
                     message: "请先选择您要操作的一条数据",
                     type: "error",
                  });
                  return false;
               }
               var dataInfo = this.selectData[0];
               if (!dataInfo) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  });
                  return false;
               }


               this.$http.RegUnquaQueryDetail(
                  { ids: [dataInfo.rumRegno] }
               ).then(res => {
                  dataInfo.details = res.result.details
                  this.actionData = {
                     cate: 1,
                     formData: this.formDataList,
                     oldData: dataInfo,
                     orderId: dataInfo.rumId,
                     printSouce: '',
                     printJurId: ''
                  }
                  this.showStatus = true
               })
               break;
            case 2:
               this.delDataAction();
               break;
            case 3:
               this.submitDataAction();
               break;
            case 4:
               this.showPrintPlan()
               break
            case 15:
               this.openFormDesign()
               break;

         }
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      showPrintPlan() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         console.log(sessionStorage.getItem('printSource'))
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(dataInfo.rumId, sessionStorage.getItem('printSource').replace(/\"/g, ""), sessionStorage
               .getItem('printJurId'))
         } else {
            return
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },

      // 提交审核
      async submitDataAction() {
     if (this.returnData.list.length <= 0) {
            this.$message({
               message: "暂无数据",
               type: "error",
            });
            return false;
         }
         
         // 检查是否有选中的数据
         if (this.selectData.length <= 0) {
            this.$message({
               message: "请先选择要删除的数据",
               type: "error",
            });
            return false;
         }

         // this.$confirm("确定要提交审核?", "提示", {
         //    confirmButtonText: "确定",
         //    cancelButtonText: "取消",
         //    type: "warning",
         // })
         //    .then(async () => {
               let responseData = await this.$http.submitUnqualifiedRegister({
                  ids: this.selectData.map(item => item.rumId),
               });
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "操作成功",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            // })
            // .catch(() => {});
      },
      // 删除数据
      delDataAction() {
         if (this.returnData.list.length <= 0) {
            this.$message({
               message: "暂无数据",
               type: "error",
            });
            return false;
         }
         
         // 检查是否有选中的数据
         if (this.selectData.length <= 0) {
            this.$message({
               message: "请先选择要删除的数据",
               type: "error",
            });
            return false;
         }
         
         // 获取选中数据的ID数组
         const selectedIds = this.selectData.map(item => item.rumId);
         const deleteCount = selectedIds.length;
         
         this.$confirm(`此操作将永久删除选中的${deleteCount}条数据, 是否继续?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: selectedIds,
               };
               let responseData = await this.$http.delUnqualifiedRegister(delData);
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: `删除成功! 共删除${deleteCount}条数据`,
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.getUnqualifiedRegister(
            this.getRequestData
         );
         
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list;
            this.returnData.pages = responseData.result.pages;
            this.returnData.total = responseData.result.total;
            this.returnData.pageNum = responseData.result.pageNum;
            this.selectedDataIndex = 0;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
},
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}
</style>